import React, { useEffect, useState } from "react";
import axios from "axios";
import $ from "jquery";
import { useNavigate,useOutletContext } from "react-router-dom";




export default function DashBoard() {
  const navigate = useNavigate();
    const { selectedNotice, setSelectedNotice } = useOutletContext();
  const [user, setUser] = useState(null);
  const [useAllAdjust, setUseAllAdjust] = useState(false);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
   const { setIsLoggedIn } = useOutletContext();

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API_BASE}/api/DashBoard`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUser(res.data);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          if (err.response.status === 401 || err.response.status === 403) {
            localStorage.removeItem("token");
            setIsLoggedIn(false);      // 로그인 상태 false 처리
            navigate("/login");         // 로그인 화면으로 리다이렉트
            return;
          }
        }
        console.error("유저 정보 불러오기 실패:", err);
      }
    };



    fetchUserInfo();

    const interval = setInterval(() => {
      const checkbox = document.querySelector("#sw-treeAllSelect");
      if (checkbox) {
        $(checkbox).on("change", function () {
          const isChecked = $(this).is(":checked");
          const $wrapper = $(this).closest(".custom-control");
          $wrapper.toggleClass("checked", isChecked);
          setUseAllAdjust(isChecked);
        });

        clearInterval(interval); // ✅ 더 이상 반복 안 하게 종료
      }
    }, 100); // 0.1초마다 체크

    return () => {
      clearInterval(interval);
      $("#sw-treeAllSelect").off("change");
    };
  }, []);

  if (!user) return <div>로딩 중...</div>;
  const monthAdjust = useAllAdjust ? user.all_month_adjust : user.month_adjust;
  const todayAdjust = useAllAdjust ? user.all_today_adjust : user.today_adjust;
  const yesterdayAdjust = useAllAdjust
    ? user.all_yesterday_adjust
    : user.yesterday_adjust;

  return (
    <div className="nk-content">
      <div className="container-fluid">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            <div className="nk-block nk-block-lg vIndex">
              <div className="card card-bordered card-stretch">
                <div className="card-inner user-view-box">
                  <div className="row g-gs">
                    <div className="col-sm-12 col-lg-5 col-xxl-5">
                      <div className="nk-block-head nk-block-head-sm">
                        <div className="nk-block-head-content">
                          <h3 className="nk-block-title page-title">
                            {user.user_id}{" "}
                            <strong
                              className="text-primary small ms-2"
                              data-placement="top"
                              data-bs-toggle="tooltip"
                              title="총 보유알"
                            >
                              <em className="icon-ccash">
                                <img src="/images/icons/icon-ccoin.png" />
                              </em>
                              <span>
                                {parseInt(user.possess_amt).toLocaleString()}
                              </span>{" "}
                              &nbsp;{" "}
                              <div
                                id="indexSpain"
                                className="btn btn-dark btn-sm"
                              >
                                <i className="fas fa-redo"></i>
                              </div>
                            </strong>
                          </h3>
                          <div className="nk-block-des text-soft">
                            <ul className="list-inline">
                              <li>
                                {" "}
                                #NO.{" "}
                                <span className="text-base">{user.idx}</span>
                              </li>
                              <li>
                                아이디 :{" "}
                                <span className="text-base">
                                  {user.user_id}
                                </span>
                              </li>
                              <li>
                                최근접속일 :
                                <span className="text-base">
                                  <span style={{ fontSize: "95%" }}>
                                    {user.last_dt}
                                  </span>
                                </span>
                              </li>
                              <li>
                                <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                                  S
                                </em>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-7 col-xxl-7">
                      <div className="card card-bordered card-full">
                        <div className="row">
                          <div className="col-2 p-1 ps-4 pt-2">
                            <h6>통합알</h6>
                          </div>
                          <div className="col-3 p-1">
                            <div className="title">회원 보유금</div>
                            <div className="amount">
                              <span>0</span>
                              <span className="ps-1 currency-usd">KRW</span>
                            </div>
                          </div>
                          <div className="col-3 p-1">
                            <div className="title">에이전트 보유금</div>
                            <div className="amount">
                              <span>{user.agent_amt.toLocaleString()}</span>
                              <span className="ps-1 currency-usd">KRW</span>
                            </div>
                          </div>
                          <div className="col-3 p-1">
                            <div className="title">총 보유금</div>
                            <div className="amount">
                              <strong>
                                <span>
                                  {(
                                    parseInt(user.possess_amt) +
                                    parseInt(user.agent_amt)
                                  ).toLocaleString()}
                                </span>
                                <span className="ps-1 currency-usd">KRW</span>
                              </strong>
                            </div>
                          </div>
                        </div>
                        <div
                          className="invest-data-history totalCash p-1"
                          style={{ textAlign: "right" }}
                        >
                          <div className="custom-control switch-onoff custom-switch ms-2">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="sw-treeAllSelect"
                            />
                            <label
                              className="custom-control-label text-nowrap"
                              htmlFor="sw-treeAllSelect"
                            >
                              <strong>하부포함</strong>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="nk-block">
              <div className="row g-gs">
                <div className="col-sm-12 col-lg-4 col-xxl-4">
                  <div className="card card-bordered card-full">
                    <div className="card-inner">
                      <div className="card-title-group mb-1">
                        <div className="card-title">
                          <h6 className="title">
                            <em className="icon ni ni-calendar-booking-fill"></em>{" "}
                            베팅내역
                          </h6>
                        </div>
                      </div>
                      <div className="tab-content mt-0">
                        <div className="tab-pane active" id="yday">
                          <div className="invest-ov gy-2">
                            <div className="subtitle">
                              <b>{user?.yesterday_date} (어제 베팅통계)</b>
                            </div>
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">베팅</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount">
                                  <span>
                                    {yesterdayAdjust.bet.toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">승</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount">
                                  <span>
                                    {yesterdayAdjust.win.toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">무</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount">
                                  <span>
                                    {yesterdayAdjust.tie.toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">취소</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount">
                                  <span>
                                    {yesterdayAdjust.cancle.toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="invest-ov gy-2">
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">수익금</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount link-primary">
                                  <span>
                                    {yesterdayAdjust.total_amt.toLocaleString()}
                                  </span>{" "}
                                  ( {yesterdayAdjust.total_persent} % ){" "}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-lg-4 col-xxl-4">
                  <div className="card card-bordered card-full">
                    <div className="card-inner">
                      <div className="card-title-group mb-1">
                        <div className="card-title">
                          <h6 className="title">
                            <em className="icon ni ni-calendar-booking-fill"></em>{" "}
                            베팅내역
                          </h6>
                        </div>
                      </div>
                      <div className="tab-content mt-0">
                        <div className="tab-pane active" id="overview">
                          <div className="invest-ov gy-2">
                            <div className="subtitle">
                              <b>{user?.today_date}(오늘 베팅통계)</b>
                            </div>
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">베팅</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount">
                                  <span>
                                    {todayAdjust.bet.toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">승</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount">
                                  <span>
                                    {todayAdjust.win.toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">무</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount">
                                  <span>
                                    {todayAdjust.tie.toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">취소</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount">
                                  <span>
                                    {todayAdjust.cancle.toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="invest-ov gy-2">
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">수익금</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount link-primary">
                                  <span>
                                    {todayAdjust.total_amt.toLocaleString()}
                                  </span>{" "}
                                  ( {todayAdjust.total_persent} % ){" "}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-lg-4 col-xxl-4">
                  <div className="card card-bordered card-full">
                    <div className="card-inner">
                      <div className="card-title-group mb-1">
                        <div className="card-title">
                          <h6 className="title">
                            <em className="icon ni ni-calendar-booking-fill"></em>{" "}
                            베팅내역
                          </h6>
                        </div>
                      </div>
                      <div className="tab-content mt-0">
                        <div className="tab-pane active" id="thismonth">
                          <div className="invest-ov gy-2">
                            <div className="subtitle">
                              <b>{user?.month_date} (이번달 베팅통계)</b>
                            </div>
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">베팅</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount">
                                  <span>
                                    {monthAdjust.bet.toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">승</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount">
                                  <span>
                                    {monthAdjust.win.toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">무</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount">
                                  <span>
                                    {monthAdjust.tie.toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">취소</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount">
                                  <span>
                                    {monthAdjust.cancle.toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="invest-ov gy-2">
                            <div className="invest-ov-details">
                              <div className="invest-ov-stats">
                                <div>
                                  <span className="amount">수익금</span>
                                </div>
                              </div>
                              <div className="invest-ov-info text-end">
                                <div className="amount link-primary">
                                  <span>
                                    {monthAdjust.total_amt.toLocaleString()}
                                  </span>{" "}
                                  ( {monthAdjust.total_persent} % ){" "}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="nk-block nk-block-lg pt-4">
              <div className="row g-gs">
                <div className="col-lg-6 col-sm-12">
                  <div className="card card-bordered card-full">
                    <div className="card-inner">
                      <div className="card-title-group">
                        <div className="card-title">
                          <h6 className="title">
                            <i className="far fa-list-alt"></i> 공지사항
                          </h6>
                        </div>
                        <div className="card-tools">
                          <a
                            className="text-soft btn btn-sm btn-icon btn-trigger"
                            href="/board/notice"
                            data-placement="top"
                            data-bs-toggle="tooltip"
                            data-bs-original-title="공지사항 게시판"
                          >
                            <em className="icon ni ni-chevron-right"></em>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="card-inner p-0">
                      <table className="table not-bg-oddeven hover-event tb-index-board table-tranx">
                        <tbody>
                          {user.notice.map((item) => {
                            const date = new Date(item.mod_dt);
                            const dateStr = date.toISOString().split("T")[0];
                            const timeStr = date.toTimeString().split(" ")[0];

                            return (
                              <tr
                                key={item.idx}
                                className="tb-tnx-item"
                                data-bs-toggle="modal"
                                data-bs-target="#modalNotiView"
                                onClick={() => setSelectedNotice(item)}
                              >
                                <td className="tb-tnx-info txt_line">
                                  <span>〓 {item.subject} 〓</span>
                                </td>
                                <td className="tb-tnx-amount is-alt text-end">
                                  <div className="tb-tnx-status">
                                    <span className="fs-12px">
                                      <span style={{ fontSize: "95%" }}>
                                        {dateStr}
                                        <font className="dateInHour">
                                          {" "}
                                          ({timeStr} UTC +9)
                                        </font>
                                      </span>
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="card card-bordered card-full">
                    <div className="card-inner">
                      <div className="card-title-group">
                        <div className="card-title">
                          <h6 className="title">
                            <i className="far fa-list-alt"></i> 업데이트
                          </h6>
                        </div>
                        <div className="card-tools">
                          <a
                            className="text-soft btn btn-sm btn-icon btn-trigger"
                            href="/board/update"
                            data-placement="top"
                            data-bs-toggle="tooltip"
                            data-bs-original-title="업데이트 게시판"
                          >
                            <em className="icon ni ni-chevron-right"></em>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="card-inner p-0">
                      <table className="table not-bg-oddeven hover-event tb-index-board table-tranx">
                        <tbody>
                          {Array.isArray(user.update) &&
                            user.update.map((item) => {
                              const date = new Date(item.mod_dt);
                              const isValid = !isNaN(date);
                              const dateStr = isValid
                                ? date.toISOString().split("T")[0]
                                : "날짜 없음";
                              const timeStr = isValid
                                ? date.toTimeString().split(" ")[0]
                                : "";

                              return (
                                <tr
                                  key={item.idx}
                                  className="tb-tnx-item"
                                  data-bs-toggle="modal"
                                  data-bs-target="#modalNotiView"
                                  onClick={() => setSelectedNotice(item)}
                                >
                                  <td className="tb-tnx-info txt_line">
                                    <span>〓 {item.subject} 〓</span>
                                  </td>
                                  <td className="tb-tnx-amount is-alt text-end">
                                    <div className="tb-tnx-status">
                                      <span className="fs-12px">
                                        <span style={{ fontSize: "95%" }}>
                                          {dateStr}
                                          {timeStr && (
                                            <font className="dateInHour">
                                              {" "}
                                              ({timeStr} UTC +9)
                                            </font>
                                          )}
                                        </span>
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
